// Smallest name size, in card pixels, that stays readable on a printed CR80 card.
const NAME_MIN_FONT_SIZE = 33

function fittedFontSize (textWidth, availableWidth, baseSize, minSize) {
  if (!textWidth || textWidth <= availableWidth) {
    return baseSize
  }
  return Math.max(minSize, Math.floor(baseSize * availableWidth / textWidth))
}

module.exports = {
  NAME_MIN_FONT_SIZE,
  fittedFontSize
}
